import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const getLeaveReqCount = (data) => {
  return http.post("/Dashboard/GetLeaveReqCount", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getAttendeceCount = (data) => {
  return http.post("/Dashboard/GetAttendeceCount", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpLeaveOverview = (data) => {
  return http.post("/Dashboard/GetEmpLeaveOverview", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpQuarterLeaveOverview = (data) => {
  return http.post("/Dashboard/GetEmpQuarterLeaveOverview", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpMonthLeaveOverview = (data) => {
  return http.post("/Dashboard/GetEmpMonthLeaveOverview", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getDailyAttendeceReport = (data) => {
  return http.post("/Dashboard/GetDailyAttendeceReport", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getQutrlyLeaveReport = (data) => {
  return http.post("/Dashboard/GetQutrlyLeaveReport", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getMonthlyLeaveReport = (data) => {
  return http.post("/Dashboard/GetMonthlyLeaveReport", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getRmTeamLeaveReqCount = (data) => {
  return http.post("/Dashboard/GetRmTeamLeaveReqCount", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEventtypes = () => {
  return http.get("/Dashboard/GetEvent_types", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getAnalytics = (data) => {
  return http.post("/Dashboard/GetAnalytics", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const DashboardService = {
  getLeaveReqCount,
  getAttendeceCount,
  getEmpLeaveOverview,
  getEmpQuarterLeaveOverview,
  getEmpMonthLeaveOverview,
  getDailyAttendeceReport,
  getQutrlyLeaveReport,
  getMonthlyLeaveReport,
  getRmTeamLeaveReqCount,
  getEventtypes,
  getAnalytics,
};

export default DashboardService;
